import React from 'react';
import Labels from './Label';
import BaseTypesPicker from './BaseTypesPicker';
import StylePicker from './StylePicker';
import cs from 'classnames';
import { collectOptions, defMenu, defQuickAppMenuId, modalType } from '../../../constants';
import Seacher from './Seacher';
import CollectBtnGroup from './CollectBtnGroup';
import Bread from './Bread';
import { setModelsModalState, useModelsModalState } from '../../../store/state';
import { translate } from '@shakkerai/util-i18n';
import { Checkbox } from '@mantine/core';

// Header 筛选条件是根据lora、checkpoint、菜单、content滚动共同决定筛选项展示条件
const Header = ({ onSubmit, modelType, className, menus, setMenus, menuPath }) => {
  const baseTypes = useModelsModalState('baseTypes');
  const keyword = useModelsModalState('keyword');
  const collectState = useModelsModalState('collectState');
  const combinedTagCode = useModelsModalState('combinedTagCode');
  const isInGlobalSearchState = useModelsModalState('isInGlobalSearchState');
  const globalSearchDataCount = useModelsModalState('globalSearchDataCount');
  const collectModels = useModelsModalState('collectModels');
  const collectType = useModelsModalState('collectType');
  const isInScrolling = useModelsModalState('isInScrolling');
  const onlySeeStoreModel = useModelsModalState('onlySeeStoreModel');

  const flag = false; // 隐藏StylePicker，数据没准备好，后面要开启

  const typPicker = () => {
    if (menuPath.level === 2 || isInGlobalSearchState) {
      return (
        <div className="flex flex-1 justify-end">
          <BaseTypesPicker value={baseTypes} onChange={(baseTypes) => setModelsModalState({ baseTypes })} />
        </div>
      );
    } else {
      const choosedChild = menuPath.menu.children.find((child) => child.choosed) ?? {};
      const supportList = [];
      Object.keys(choosedChild).forEach((key) => {
        if (key.startsWith('support') && choosedChild[key]) {
          // support这种拼接基于后端约定
          const menu = menus.find((menu) => `support${menu.dimension}`.toLowerCase() === key.toLowerCase());
          menu?.children?.length &&
            supportList.push({
              key,
              defOption: menu.tagLabel,
              options: menu.children,
            });
        }
      });
      return (
        <div className="flex flex-1 justify-end">
          {modelType === modalType.LORA &&
            flag &&
            supportList.map(({ options, key, defOption }, idx) => (
              <StylePicker
                key={idx}
                options={options}
                targetKey={key}
                defOption={defOption}
                value={combinedTagCode[key]}
                menus={menus}
                menuPath={menuPath}
                onChange={(e) =>
                  setModelsModalState({
                    combinedTagCode: {
                      ...combinedTagCode,
                      ...e,
                    },
                  })
                }
              />
            ))}
          <BaseTypesPicker value={baseTypes} onChange={(baseTypes) => setModelsModalState({ baseTypes })} />
        </div>
      );
    }
  };

  const asyncStateToMenu = (e) => {
    if (!e.isInGlobalSearchState) {
      const newMenus = [...menus].map((item) => {
        if (`${item.id}` === `${defMenu.hotRecommendId}` && modelType === modalType.LORA) {
          return { ...item, choosed: true };
        }
        if (`${item.id}` === `${defMenu.presetModelId}` && modelType === modalType.CHECKPOINT) {
          return { ...item, choosed: true };
        }
        if (`${item.id}` === `${defQuickAppMenuId}` && modelType === modalType.WORKFLOW) {
          return { ...item, choosed: true };
        }
        return item;
      });
      setMenus(newMenus);
    }
    setModelsModalState(e);
  };
  return (
    <div
      className={cs('flex flex-col items-center pl-5', className)}
      style={{ boxShadow: isInScrolling ? 'rgba(0, 0, 0, 0.05) 0px 4px 8px 0px' : '' }}
    >
      <Seacher value={keyword} onChange={(e) => asyncStateToMenu(e)} modelType={modelType} />
      {isInGlobalSearchState ? (
        <div className="flex w-full flex-1 justify-between py-2">
          <span className="text-[#7A7A7A] font-normal text-[13px]">
            {translate('model_search')}({globalSearchDataCount})
          </span>
          <div className="flex justify-center items-center">
            <Checkbox
              size="xs"
              checked={onlySeeStoreModel}
              onChange={(event) => setModelsModalState({ onlySeeStoreModel: event.currentTarget.checked })}
            />
            <span className="flex-shrink-0 text-[#2d2d2d] flex justify-center items-center mr-3 ml-1 hover:text-[#2d2d2d] text-[13px]">
              仅看已收藏
            </span>
            {modelType !== modalType.WORKFLOW && (
              <BaseTypesPicker value={baseTypes} onChange={(baseTypes) => setModelsModalState({ baseTypes })} />
            )}
          </div>
        </div>
      ) : (
        <div className={cs('flex justify-between w-full', menuPath.level === 1 ? 'py-4' : 'pb-4')}>
          {menuPath.level === 1 && <Labels menuPath={menuPath} menus={menus} setMenus={setMenus} />}
          {(menuPath.level === 2 || collectState.data) && (
            <Bread menuPath={menuPath} menus={menus} setMenus={setMenus} />
          )}
          {menuPath.menu.code === defMenu.collectModelId && (
            <div className="w-full flex justify-between items-center">
              <span className="text-[#7A7A7A] font-normal text-[13px]">
                收藏{`${modelType === modalType.WORKFLOW ? '' : '模型'}`}({collectModels[collectType]?.length ?? '-'})个
              </span>
              <CollectBtnGroup collectOptions={collectOptions} />
            </div>
          )}
          {menuPath.level !== 0 && modelType !== modalType.WORKFLOW && typPicker()}
        </div>
      )}
    </div>
  );
};

export default Header;
